import { gql } from '@apollo/client';

export const FETCH_IMPORT_FILE_BREADCRUMB = gql`
  query fetchImportFileLineBreadcrumb($importFileId: ObjectID!) {
    fetchImportFile(importFileId: $importFileId) {
      importFile {
        type
        fileDocument {
          id
          name
        }
      }
    }
  }
`;
